<template>
  <main class="wrapper">
    <div class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
      <div itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <nuxt-link to="/" itemprop="item">
          <span itemprop="name">Главная</span>
        </nuxt-link>
        <meta itemprop="position" content="1">
      </div>

      <div v-if="post.category" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        /
        <nuxt-link :to="`/?type=${encodeURIComponent(post.category)}`" itemprop="item">
          <span itemprop="name">{{ post.category }}</span>
        </nuxt-link>
        <meta itemprop="position" content="2">
      </div>

      <div v-if="post.genres && post.genres.length" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        /
        <nuxt-link :to="`/?genre=${encodeURIComponent(post.genres[0])}`" itemprop="item">
          <span itemprop="name">{{ post.genres[0] }}</span>
        </nuxt-link>
        <meta itemprop="position" content="3">
      </div>

      <div itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        /
        <span itemprop="name">
          {{ post.title }}
        </span>
        <meta itemprop="position" content="4">
      </div>
    </div>

    <section class="comics-page-item">
      <div v-if="isDesktop" class="left">
        <div class="poster">
          <img :data-src="post.poster" :alt="`Постер к комиксу ${post.title}`" src="/static_files/no-poster.png" class="lazyload" />
        </div>
        <nuxt-link v-if="!blocked" :to="`/comics/${post.id}/chapter/0`" tag="div" class="read">
          <img src="/static_files/icons/open-book.svg" alt="">
          Начать читать
        </nuxt-link>
        <Fav :fav="post" />
      </div>
      <div v-else class="left">
        <div style="display:grid;grid-template-columns:30vw auto;grid-gap:10px;">
          <div class="poster">
            <img :data-src="post.poster" :alt="`Постер к комиксу ${post.title}`" src="/static_files/no-poster.png" class="lazyload" />
          </div>
          <div>
            <h1>{{ post.title }}</h1>
            <div class="meta">
              <span class="category">{{ post.category }} &middot;</span>
              <nuxt-link v-if="post.year" :to="`/?year=${post.year}`" tag="span">{{ post.year }} &middot;</nuxt-link>
              <span v-if="post.status" class="status">{{ post.status }}</span>
            </div>
            <div v-if="post.stats" class="stats">
              <div v-if="post.stats.views">
                <span>
                  <!-- <img src="/static_files/icons/view.svg" alt=""> -->
                  <i class="view" />
                  {{ post.stats.views }}
                </span>
              </div>
              <div v-if="post.stats.rating">
                <span @click="(showRatings = !showRatings)">
                  <!-- <img src="/static_files/icons/star-gold.svg" alt=""> -->
                  <i class="star" />
                  {{ post.stats.rating | filterRating }}
                </span>

                <transition name="bounce">
                  <div v-if="showRatings" class="ratings">
                    <i @click="(showRatings = false)" class="close" />
                    <ul>
                      <li @mouseenter="(setRating = 1)">
                        <img :src="`/static_files/icons/star-${setRating >= 1 ? 'active' : 'gold'}.svg`" alt="">
                      </li>
                      <li @mouseenter="(setRating = 2)">
                        <img :src="`/static_files/icons/star-${setRating >= 2 ? 'active' : 'gold'}.svg`" alt="">
                      </li>
                      <li @mouseenter="(setRating = 3)">
                        <img :src="`/static_files/icons/star-${setRating >= 3 ? 'active' : 'gold'}.svg`" alt="">
                      </li>
                      <li @mouseenter="(setRating = 4)">
                        <img :src="`/static_files/icons/star-${setRating >= 4 ? 'active' : 'gold'}.svg`" alt="">
                      </li>
                      <li @mouseenter="(setRating = 5)">
                        <img :src="`/static_files/icons/star-${setRating === 5 ? 'active' : 'gold'}.svg`" alt="">
                      </li>
                    </ul>
                    <div style="margin-top:30px;">
                      <button @click="postRating">Оценить</button>
                    </div>
                  </div>
                </transition>
              </div>
              <div v-if="post.stats.likes">
                <span @click="postLike">
                  <i v-if="!user" class="heart" />
                  <i v-else class="heart" :class="post.stats.likes.includes(user.id) ? 'active' : ''" />
                  {{ post.stats.likes.length }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <nuxt-link v-if="!blocked" :to="`/comics/${post.id}/chapter/0`" tag="div" class="read">
          <img src="/static_files/icons/open-book.svg" alt="">
          Начать читать
        </nuxt-link>
        <Fav :fav="post" />
      </div>
      <div class="right">
        <template v-if="isDesktop">
          <h1>{{ post.title }}</h1>
          <div class="meta">
            <span class="category">{{ post.category }} &middot;</span>
            <nuxt-link v-if="post.year" :to="`/?year=${post.year}`" tag="span">{{ post.year }} &middot;</nuxt-link>
            <span v-if="post.status" class="status">{{ post.status }}</span>
          </div>
        </template>

        <div v-if="isDesktop && post.stats" class="stats">
          <div v-if="post.stats.views">
            Всего просмотров
            <span>
              <!-- <img src="/static_files/icons/view.svg" alt=""> -->
              <i class="view" />
              {{ post.stats.views }}
            </span>
          </div>
          <div v-if="post.stats.rating">
            Рейтинг
            <span @click="(showRatings = !showRatings)">
              <!-- <img src="/static_files/icons/star-gold.svg" alt=""> -->
              <i class="star" />
              {{ post.stats.rating | filterRating }}
            </span>

            <transition name="bounce">
              <div v-if="showRatings" class="ratings">
                <i @click="(showRatings = false)" class="close" />
                <ul>
                  <li @mouseenter="(setRating = 1)">
                    <img :src="`/static_files/icons/star-${setRating >= 1 ? 'active' : 'gold'}.svg`" alt="">
                  </li>
                  <li @mouseenter="(setRating = 2)">
                    <img :src="`/static_files/icons/star-${setRating >= 2 ? 'active' : 'gold'}.svg`" alt="">
                  </li>
                  <li @mouseenter="(setRating = 3)">
                    <img :src="`/static_files/icons/star-${setRating >= 3 ? 'active' : 'gold'}.svg`" alt="">
                  </li>
                  <li @mouseenter="(setRating = 4)">
                    <img :src="`/static_files/icons/star-${setRating >= 4 ? 'active' : 'gold'}.svg`" alt="">
                  </li>
                  <li @mouseenter="(setRating = 5)">
                    <img :src="`/static_files/icons/star-${setRating === 5 ? 'active' : 'gold'}.svg`" alt="">
                  </li>
                </ul>
                <div style="margin-top:30px;">
                  <button @click="postRating">Оценить</button>
                </div>
              </div>
            </transition>
          </div>
          <div v-if="post.stats.likes">
            Понравилось
            <span @click="postLike">
              <i v-if="!user" class="heart" />
                  <i v-else class="heart" :class="post.stats.likes.includes(user.id) ? 'active' : ''" />
              {{ post.stats.likes.length }}
            </span>
          </div>
        </div>

        <div class="menu">
          <div @click="menuCurrent = 'about'" :class="{ active: menuCurrent === 'about' }" class="item">
            Обзор
          </div>
          <div v-if="post.parts.length" @click="menuCurrent = 'parts'" :class="{ active: menuCurrent === 'parts' }" class="item">
            Главы <span v-if="post.parts && post.parts.length">{{ post.parts.length }}</span>
          </div>
          <div @click="menuCurrent = 'comments'" :class="{ active: menuCurrent === 'comments' }" class="item">
            Комментарии <span>{{ post.comments_count }}</span>
          </div>
        </div>

        <template v-if="menuCurrent === 'about'">
          <div class="body">
            <div v-if="post.genres && post.genres.length" class="genres">
              <nuxt-link v-for="g in post.genres" :key="`info-genre-${g}`" :to="`/?genre=${encodeURIComponent(g)}`" tag="div" class="item">
                {{ g }}
              </nuxt-link>
            </div>

            <div v-if="post.desc" class="description">{{ post.desc }}</div>

            <div class="others">
              <div class="h2">Дополнительная информация</div>
              <div>
                <strong v-if="post.author.length">Авторы:</strong>
                <ul v-if="post.author.length" class="author">
                  <li v-for="a in post.author" :key="`post-author-${a}`">
                    <nuxt-link :to='`/?author=${a}`'>{{ a }}</nuxt-link>
                  </li>
                </ul>
              </div>
              <div>
                <strong v-if="post.translation.length">Перевод:</strong>
                <ul v-if="post.translation.length" class="translation">
                  <li v-for="t in post.translation" :key="`post-translation-${t}`">
                    <nuxt-link :to='`/?translation=${t}`'>{{ t }}</nuxt-link>
                  </li>
                </ul>
              </div>
              <h3 v-if="post.update" class="update">
                {{ post.update }}
                <sup v-if="!blocked">
                  <nuxt-link :to="`/comics/${post.id}/chapter/0`" style="color:#cfa100;">
                    Читать
                  </nuxt-link>
                </sup>
              </h3>
            </div>

            <div v-if="post.related_anime && post.related_anime.length" style="margin:30px 0 30px;">
              <div class="h2">Связнное аниме</div>
              <slider-component :videos="{ items: related_anime, type: 'watch' }" />
            </div>
          </div>
        </template>
        <template v-else-if="menuCurrent === 'parts'">
          <div class="body">
            <div v-if="!blocked" class="parts">
              <nuxt-link
                v-for="(p, index) in post.parts"
                :to="`/comics/${post.id}/chapter/${index}`"
                :key="`info-part-${index}`"
                tag="div"
                class="item"
              >
                {{ p.title }}
              </nuxt-link>
            </div>
            <div v-else style="margin-top:10px;">
              <h3>Главы удалены по просьбе правообладателя. </h3>
              <p>
                <strong>Добавьте комикс в Списки</strong>, чтобы не потерять и следить за обновлениями.
              </p>
            </div>

          </div>
        </template>
        <template v-else-if="menuCurrent === 'comments'">
          <div class="body">
            <Comments :id="`comics-${post.id}`" />
          </div>
        </template>
      </div>
    </section>

    <section v-if="related_anime && related_anime.length" style="margin-top:40px;">
      <div style="margin:0px 0px 10px 10px;font-size:2rem;font-weight:600;">
        Связные аниме
      </div>

      <div class="slider-wrapper">
        <div :style="`width:${related_anime.length * 180}px;`" class="slider">
          <div v-for="item in related_anime" :key="`slider-item-${item.id}`" class="item">
            <a :href="`https://1xanime.ru/film/${postUrl(item.kinopoisk_id, item.title_ru)}`" target="_blank">
              <div :title="item.title_ru" class="poster">
                <img :data-src="item.poster" :alt="item.title" src="/static_files/no-poster.png" class="lazyload">
                <!-- <img :data-src="item.poster" :alt="item.title_ru" src="/static_files/no-poster.png" class="lazy"> -->
              </div>
              <strong>{{ item.title_ru }}</strong>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- <div style="margin:20px 0px;">
      <div id="yandex_rtb_R-A-1202748-6"></div>
    </div> -->

    <section v-if="related && related.length" style="margin-top:40px;">
      <div style="margin:0px 0px 10px 10px;font-size:2rem;font-weight:600;">
        Вам может понравиться
      </div>
      <!-- <Slider :videos="{ items: related, type: 'comics' }" /> -->

      <div class="slider-wrapper">
        <div :style="`width:${related.length * 180}px;`" class="slider">
          <div v-for="item in related" :key="`slider-item-${item.id}`" class="item">
            <nuxt-link :to="`/comics/${postUrl(item.id, item.title)}`">
              <div class="poster">
                <img :data-src="item.poster" :alt="item.title" src="/static_files/no-poster.png" class="lazyload">
                <!-- <img :data-src="item.poster" :alt="item.title" src="/static_files/no-poster.png" class="lazy"> -->
              </div>
              <strong>{{ item.title }}</strong>
            </nuxt-link>
          </div>
        </div>
      </div>
    </section>

    <LastComments :comments="comments" />
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    Fav: () => import('~/components/Fav.vue'),
    Comments: () => import('~/components/Comments.vue'),
    LastComments: () => import('~/components/LastComments.vue'),
    // Slider: () => import('~/components/Slider.vue'),
  },
  filters: {
    filterRating(val) {
      if (!val.length) return 0
      let sum = 0
      val.forEach(el => {
        sum += el.rating
      })
      return sum / val.length
    },
    filterDate(val) {
      const value = val
      const months = [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек'
      ]
      const day =
        new Date(value).getDate() >= 10
          ? new Date(value).getDate()
          : '0' + new Date(value).getDate()
      const month = new Date(value).getMonth()
      const year = new Date(value).getFullYear()
      const hour =
        new Date(value).getHours() >= 10
          ? new Date(value).getHours()
          : '0' + new Date(value).getHours()
      const min =
        new Date(value).getMinutes() >= 10
          ? new Date(value).getMinutes()
          : '0' + new Date(value).getMinutes()
      return `${day} ${months[month]} ${year} в ${hour}:${min}`
    }
  },
  head() {
    const title = `${this.q ? `Начните читать ` : ''}${this.post.category} ${this.post.title} (${this.post.year}) читать бесплатно на русском`
    const canonical = `https://1xmanga.ru/comics/${this.postUrl(this.post.id, this.post.title)}`
    return {
      title: title,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: canonical
        }
      ],
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.post.category.toLowerCase()} ${this.post.title} читать бесплатно на русском`
        },
        {
          hid: 'description',
          name: 'description',
          content: `${this.q ? 'Вы читаете' : 'Читайте'} комикс ${this.post.category.toLowerCase()} ${this.post.title} (${this.post.year}) онлайн бесплатно с переводом на русский у нас!`
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: canonical
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: `${this.q ? 'Вы читаете' : 'Читайте'} комикс ${this.post.category.toLowerCase()} ${this.post.title} (${this.post.year}) онлайн бесплатно с переводом на русский у нас!`
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.post.poster
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: `${this.post.category.toLowerCase()} ${this.post.title}`
        },
        {
          hid: 'twitter:description',
          property: 'twitter:description',
          content: this.post.desc
        },
        {
          hid: 'twitter:image',
          property: 'twitter:image',
          content: this.post.poster
        }
      ]
    }
  },
  async asyncData({ $axios, params, error, query }) {
    const id = params.id.includes('-')
      ? params.id.slice(0, params.id.indexOf('-'))
      : params.id
    const { data } = await $axios.get(`/api/comics/${id}`)
    if (data.error) {
      return error(data.error)
    } else {
      return {
        showRatings: false,
        setRating: 1,
        menuCurrent: 'about',
        q: query.q || '',
        id,
        ...data,
      }
    }
  },
  computed: {
    ...mapState(['user', 'isDesktop']),
    fullPath() {
      return `https://1xmanga.ru/comics/${this.postUrl(this.id, this.post.title)}`
    }
  },
  mounted() {
//     if (!this.user || (this.user && this.user.group !== 777)) {
//       const rsyaHorizon = document.createElement('script')
//       rsyaHorizon.innerHTML = `
// window.yaContextCb.push(()=>{
//   Ya.Context.AdvManager.render({
//     renderTo: 'yandex_rtb_R-A-1202748-6',
//     blockId: 'R-A-1202748-6'
//   })
// })`
//       document.body.appendChild(rsyaHorizon)
//     }
    const slider = document.querySelector('.slider-wrapper')
    if (slider) slider.addEventListener('scroll', this.lazyLoadImgs)
  },
  beforeDestroy() {
    const slider = document.querySelector('.slider-wrapper')
    if (slider) slider.removeEventListener('scroll', this.lazyLoadImgs)
  },
  methods: {
    async postRating() {
      if (!this.user) {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }
      await this.$axios.post(`/api/comics/${this.id}/rating`, { rating: this.setRating })
      this.showRatings = false
      this.$store.commit('setError', { status: 'ok', msg: 'Ваш голос принят' })
      setTimeout(() => this.$store.commit('clearError'), 2000)
      const rating = this.post.stats.rating.map(el => {
        if (el.user_id === this.user.id) {
          el.rating = this.setRating
        }
        return el
      })
      this.post.stats.rating = rating
      this.setRating = 1
    },
    async postLike() {
      if (!this.user) {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }
      const { data } = await this.$axios.post(`/api/comics/${this.id}/like`)
      if (!data.error) {
        const post = this.post
        if (data.action === 'plus') {
          post.stats.likes.push(data.user_id)
        } else {
          const likes = post.stats.likes.filter(el => el !== this.user.id)
          post.stats.likes = likes
        }
      }
    },
  }
}
</script>

<style src="~/assets/comics-id.styl" lang="stylus">
